import React, { useState, useEffect } from "react";
import { useAnalyzeLayout } from "../AnalyzeLayoutContext";

import DataGrid, {
  Column,
  Paging,
  FilterRow,
  HeaderFilter,
  Selection,
  FilterPanel
} from 'devextreme-react/data-grid';

import TreeList, {
  Column as TreeListColumn,
  SearchPanel,
  Selection as TreeListSelection
} from "devextreme-react/tree-list";


const DataTab = () => {
  const { filters, setFilters } = useAnalyzeLayout();
  const [parsedSelectedAssets, setParsedSelectedAssets] = useState([]);

  useEffect(() => {
    let selectedAssets = localStorage.getItem(`multiple-asset-selection-records-${filters.tenantID}`) || "[]";
    let parsedSelectedAssets = JSON.parse(selectedAssets);
    setParsedSelectedAssets(parsedSelectedAssets || []);
  }, []);


  return(
    <>
      <div style={{ padding: "10px" }}>
        <DataGrid
          id="gridContainer"
          // dataSource={dataSource}
          dataSource={parsedSelectedAssets}
          keyExpr="id"
          noDataText="No records available"
          showColumnLines={false}
          showRowLines={true}
          allowColumnReordering={true}
          allowColumnResizing={true}
          columnResizingMode="nextColumn"
          columnMinWidth={80}
          columnAutoWidth={true}
          // height={heightOfGrid}
        >
          {/* Virtual scrolling for performance */}
          {/* <Scrolling mode="virtual" useNative={true} /> */}

          {/* No loading panel */}
          {/* <LoadPanel enabled={false} /> */}

          {/* Filters */}
          <FilterRow visible={true} applyFilter="auto" />
          <HeaderFilter visible={true} />
          <SearchPanel visible={true} width={240} placeholder="Search..." />

          {/* Pagination */}
          <Paging enabled={true} />

          {/* Export option */}
          {/* <Export enabled={true} /> */}

          {/* Example columns */}
          <Column dataField="name" caption="Name" dataType="string" width={190} />
          <Column dataField="type.name" caption="Type" dataType="string" />
          <Column dataField="event" caption="Latest Event" dataType="string" visible={false}/>
          <Column
            dataField="motionDistance"
            caption="Distance Travelled[m] (Last 7 days)"
            dataType="number"
            visible={false}
          />
          <Column
            dataField="motionDuration"
            caption="Motion Duration (Last 7 days)"
            dataType="string"
            visible={false}
          />
          <Column dataField="status" caption="Status" dataType="string" visible={false} />
          <Column dataField="lastKnownLocation.name" caption="Space" dataType="string" />
          <Column
            dataField="lastKnownLocation.timestamp"
            caption="Location Update Time"
            dataType="datetime"
            format="EEE MMM dd yyyy, hh:mm a"
          />
          <Column dataField="processState" caption="Process State" dataType="string" visible={false} />
        </DataGrid>
      </div>
    </>
  ) 
}

export default DataTab;